import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from "../../components/Link";
import s from './DocumentVerification.css';
import cs from '../../components/commonStyle.css';
import cx from 'classnames';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

import DocumentUpload from '../../components/DocumentUpload';
import DashboardSideMenu from '../../components/Dashboard/DashboardSideMenu';
import scanIcon from '../../../public/SiteIcons/scanIconWhite.svg';
import arrowRight from '../../../public/SiteIcons/arrow-right-white.svg';
import { Button } from 'react-bootstrap/lib/InputGroup';
import ScanQRCodeModal from '../../components/ScanQRCodeModal/ScanQRCodeModal';

import FileIcon from '../../../public/SiteIcons/fileIcon.svg';
import FileIconRed from '../../../public/SiteIcons/fileIconRed.svg';
import verifyCheck from '../../../public/SiteIcons/verifyCheck.svg';
import verifyFailed from '../../../public/SiteIcons/verifyFailed.svg';

import { GoTrash } from "react-icons/go";
import { FaCheckCircle } from "react-icons/fa";

class DocumentVerification extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  state = {
    showScanQRModal: false,
  };

  toggleScanQRModal = () => {
    this.setState(prevState => ({
      showScanQRModal: !prevState.showScanQRModal
    }));
  };

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <Grid fluid className={'listingContainer'}>
        <Row>
          <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
            <DashboardSideMenu isTrustVerfiedPage />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
            <div className={cx('youcarsBg', 'documentDropCss')}>
              <h3 className={s.infoTitle}>
                <FormattedMessage {...messages.documentverificaiton} />
              </h3>
              <DocumentUpload placeholder={formatMessage(messages.documentUploadPlaceholder)} />
            </div>
          </Col>
        </Row>

        <ScanQRCodeModal
          onClose={this.toggleScanQRModal}
          show={this.state.showScanQRModal}
        />
      </Grid>
    );
  }
}

export default injectIntl(withStyles(s, cs)(DocumentVerification));
